// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.filterstate-popover-uploader {
  color: white;
  background-color: #12234f;
  border-radius: 3px;
  box-shadow: 0px 0px 5px #12234f;
  padding: 5px;
  font-size: 1.3rem;
  border: 1px solid #257ee0;
  cursor: pointer; }
  .filterstate-popover-uploader .popover-header {
    color: white;
    background-color: #12234f;
    font-size: 1.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 14px; }
  .filterstate-popover-uploader .popover-body {
    color: white;
    background-color: #12234f; }
  .filterstate-popover-uploader .uploader-button {
    width: 100px;
    margin: 10px; }
    .filterstate-popover-uploader .uploader-button svg {
      pointer-events: none; }
    .filterstate-popover-uploader .uploader-button span {
      pointer-events: none; }
    .filterstate-popover-uploader .uploader-button div {
      pointer-events: none; }
  .filterstate-popover-uploader .uploader-nodisplay {
    display: none; }

.filterstate-popover {
  color: white;
  background-color: #12234f;
  border-radius: 3px;
  box-shadow: 0px 0px 5px #12234f;
  padding: 5px;
  width: fit-content;
  max-width: 500px;
  font-size: 1.3rem;
  border: 1px solid #257ee0;
  cursor: pointer; }
  .filterstate-popover .popover-header {
    color: white;
    background-color: #12234f;
    font-size: 1.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 14px; }
  .filterstate-popover .popover-body {
    color: white;
    background-color: #12234f; }

#filterstate-filter-popover-upload {
  max-width: 400px; }

.form-floating .form-select {
  color: white; }

.filter-dropdown-group {
  height: 58px;
  width: 100%; }
  .filter-dropdown-group .filter-dropdown-toggle {
    height: 58px;
    width: 100%;
    background-color: #051D3E; }
    .filter-dropdown-group .filter-dropdown-toggle span {
      width: 90%;
      display: inline-flex;
      vertical-align: sub;
      opacity: .7; }
  .filter-dropdown-group .filter-dropdown-floating label {
    font-size: .8em;
    color: #ffffff5c;
    transform: translateY(-17px); }
  .filter-dropdown-group a, .filter-dropdown-group input {
    background-color: #051D3E;
    border: none;
    color: white; }

.filter-dropdown-menu {
  overflow-y: auto;
  max-height: 40vh;
  background-color: unset !important; }

.fs-query-input .wmr-dq-button-cont {
  display: flex;
  flex-direction: row;
  padding: 5px; }

.fs-query-input .wmr-dq-button-label {
  width: 120px;
  min-width: 120px;
  margin-left: 10px;
  vertical-align: sub; }

.fs-query-input .wmr-dq-button-form-label {
  width: 120px;
  min-width: 120px;
  margin-left: 10px; }

.fs-query-input .wmr-dq-button {
  padding: 0px; }

.fs-query-input .wmr-dq-submit {
  margin-top: 10px;
  position: absolute;
  bottom: 8px;
  margin-left: 37%; }
  .fs-query-input .wmr-dq-submit .spinners-grow {
    width: 1.3em;
    height: 1.3em; }

.fs-query-input .wmr-dq-submit-status {
  position: absolute;
  bottom: 55px;
  width: 640px;
  text-align: center; }
  .fs-query-input .wmr-dq-submit-status .alert {
    height: 30px;
    padding: 0px;
    margin-top: 20px; }

.fs-query-input .fs-column-wqp {
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin-left: 10px;
  margin-top: 30px;
  width: 38%;
  min-width: 190px;
  font-size: 1em;
  max-width: 300px; }
  .fs-query-input .fs-column-wqp .fs-col-results {
    display: flex;
    flex-direction: column;
    padding: 5px;
    margin-top: 0px; }

.fs-query-input .fs-column {
  padding: 5px;
  color: white !important; }
  .fs-query-input .fs-column form-floating > .form-control:focus ~ label, .fs-query-input .fs-column .form-floating > .form-control:not(:placeholder-shown) ~ label, .fs-query-input .fs-column .form-floating > .form-control-plaintext ~ label, .fs-query-input .fs-column .form-floating > .form-select ~ label {
    color: white;
    opacity: 0.65;
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .fs-query-input .fs-column .form-floating > .form-control:focus ~ label::after, .fs-query-input .fs-column .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .fs-query-input .fs-column .form-floating > .form-control-plaintext ~ label::after, .fs-query-input .fs-column .form-floating > .form-select ~ label::after {
    background-color: unset; }
  .fs-query-input .fs-column .fs-column-floating label {
    text-align: center;
    width: 100%; }
  .fs-query-input .fs-column .fs-column-button {
    transform: scale(0.8); }
  .fs-query-input .fs-column select, .fs-query-input .fs-column textarea {
    background-color: #051D3E;
    border: none;
    color: #ffffff5c; }
  .fs-query-input .fs-column .wmr-dq-dp {
    width: 100px; }
  .fs-query-input .fs-column .react-datepicker-wrapper {
    width: 120px !important; }
  .fs-query-input .fs-column form input[type="text"] {
    background-color: #021d3e;
    border: none;
    color: #fff !important; }
  .fs-query-input .fs-column .form-floating label {
    white-space: pre-line; }
  .fs-query-input .fs-column .form-floating input[type="text"] {
    background-color: #021d3e;
    border: none;
    color: #fff !important; }

.filterstate-popover-query {
  min-width: 690px;
  height: calc(100vh - 130px);
  max-height: 720px; }
  .filterstate-popover-query .popover-body {
    padding-top: 5px;
    padding-left: 10px;
    padding-bottom: 5px;
    height: calc(100% - 90px); }
    .filterstate-popover-query .popover-body .fs-query-input .table-container {
      max-height: 50vh;
      overflow: auto; }

.FilterState {
  display: inline-flex;
  align-self: center;
  margin-right: 12px; }
  .FilterState .fs-container {
    min-width: 143px;
    color: white;
    background-color: #12234f;
    border-radius: 5px;
    height: 35px;
    display: flex;
    align-items: center;
    padding-right: 4px; }
  .FilterState .fs-container-wide {
    min-width: 170px;
    color: white;
    background-color: #12234f;
    border-radius: 5px;
    height: 35px;
    display: flex;
    align-items: center;
    padding-left: 4px;
    padding-right: 1px; }
  .FilterState .fs-container-date {
    white-space: nowrap; }
  .FilterState .fs-calendar-icon {
    margin-left: 8px;
    margin-right: 4px; }
  .FilterState .fs-span {
    margin-left: 5px;
    opacity: .8; }
  .FilterState .fa-filter {
    margin-left: 10px; }
  .FilterState .fs-span-app {
    margin-left: 9px;
    opacity: .8;
    pointer-events: none;
    max-width: 13vw;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 4px;
    overflow: hidden; }
  .FilterState .fs-span-wide {
    margin-left: 9px;
    opacity: .8;
    pointer-events: none;
    max-width: 18vw;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 4px;
    overflow: hidden; }
  .FilterState .fs-span-end {
    margin-right: 10px;
    opacity: .8; }
  .FilterState #filterstate-filter-div {
    cursor: pointer; }
  .FilterState #filterstate-fs-container:hover {
    background-color: #257ee0;
    cursor: pointer; }
  .FilterState #filterstate-filter-div:hover {
    background-color: #257ee0; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/shared/FilterState.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACpBrD;EACI,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,eAAe,EAAA;EARnB;IAWQ,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,iDAAgD;IAChD,oBAAoB,EAAA;EAf5B;IAmBQ,YAAY;IACZ,yBAAyB,EAAA;EApBjC;IAwBQ,YAAY;IACZ,YAAY,EAAA;IAzBpB;MA4BY,oBAAoB,EAAA;IA5BhC;MAgCY,oBAAoB,EAAA;IAhChC;MAoCY,oBAAoB,EAAA;EApChC;IAyCQ,aAAa,EAAA;;AAKrB;EACI,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe,EAAA;EAVnB;IAaQ,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,iDAAgD;IAChD,oBAAoB,EAAA;EAjB5B;IAqBQ,YAAY;IACZ,yBAAyB,EAAA;;AAIjC;EACI,gBACJ,EAAA;;AAEA;EAEQ,YAAY,EAAA;;AAIpB;EACI,YAAY;EACZ,WAAW,EAAA;EAFf;IAKQ,YAAY;IACZ,WAAW;IACX,yBAAyB,EAAA;IAPjC;MAUY,UAAU;MACV,oBAAoB;MACpB,mBAAmB;MACnB,WAAW,EAAA;EAbvB;IAmBY,eAAe;IACf,gBAAgB;IAChB,4BAA4B,EAAA;EArBxC;IA0BQ,yBAAyB;IACzB,YAAY;IACZ,YAAY,EAAA;;AAIpB;EACI,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC,EAAA;;AAItC;EAEQ,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAJpB;EAQQ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB,EAAA;;AAX3B;EAeQ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB,EAAA;;AAjBzB;EAqBQ,YAAY,EAAA;;AArBpB;EAyBQ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;EA5BxB;IA+BY,YAAY;IACZ,aAAa,EAAA;;AAhCzB;EAsCQ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB,EAAA;EAzC1B;IA6Ca,YAAY;IACZ,YAAY;IACZ,gBAAgB,EAAA;;AA/C7B;EAoDQ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,gBAAgB,EAAA;EA5DxB;IA+DY,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe,EAAA;;AAlE3B;EAuEQ,YAAY;EA6BZ,uBAAsB,EAAA;EApG9B;IA0Ec,YAAY;IACZ,aAAa;IACb,8DAA8D,EAAA;EA5E5E;IAgFY,uBAAuB,EAAA;EAhFnC;IAqFgB,kBAAkB;IAClB,WAAW,EAAA;EAtF3B;IA2FW,qBAAoB,EAAA;EA3F/B;IA+FY,yBAAyB;IACzB,YAAY;IACZ,gBAAgB,EAAA;EAjG5B;IAuGY,YAAY,EAAA;EAvGxB;IA2GY,uBAAuB,EAAA;EA3GnC;IA+GY,yBAAyB;IACzB,YAAY;IACZ,sBAAsB,EAAA;EAjHlC;IAsHgB,qBAAoB,EAAA;EAtHpC;IA2HY,yBAAyB;IACzB,YAAY;IACZ,sBAAsB,EAAA;;AAMlC;EACG,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB,EAAA;EAHpB;IAKI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB,EAAA;IAR7B;MAYY,gBAAgB;MAChB,cAAc,EAAA;;AAQ1B;EACI,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB,EAAA;EAHtB;IAOQ,gBAAgB;IAChB,YAAY;IACZ,yBDnRiC;ICoRjC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB,EAAA;EAd1B;IAmBQ,gBAAgB;IAChB,YAAY;IACZ,yBD/RiC;ICgSjC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB,EAAA;EA3B1B;IA+BQ,mBAAmB,EAAA;EA/B3B;IAmCQ,gBAAgB;IAChB,iBAAiB,EAAA;EApCzB;IAwCQ,gBAAgB;IAChB,WAAW,EAAA;EAzCnB;IA6CQ,iBAAiB,EAAA;EA7CzB;IAiDQ,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IAEpB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB,EAAA;EAzDxB;IA6DQ,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IAEpB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB,EAAA;EArExB;IA0EQ,kBAAkB;IAClB,WAAW,EAAA;EA3EnB;IA+EQ,eAAe,EAAA;EA/EvB;IAmFQ,yBAAyB;IACzB,eAAe,EAAA;EApFvB;IAwFQ,yBAAyB,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n\n.filterstate-popover-uploader {\n    color: white;\n    background-color: #12234f;\n    border-radius: 3px;\n    box-shadow: 0px 0px 5px #12234f;\n    padding: 5px;\n    font-size: 1.3rem;\n    border: 1px solid #257ee0;\n    cursor: pointer;\n\n    .popover-header {\n        color: white;\n        background-color: #12234f;\n        font-size: 1.5rem;\n        border-bottom: 1px solid rgba(255, 255, 255, .2);\n        padding-bottom: 14px;\n    }\n\n    .popover-body {\n        color: white;\n        background-color: #12234f;\n    }\n\n    .uploader-button {\n        width: 100px;\n        margin: 10px;\n\n        svg {\n            pointer-events: none;\n        }\n\n        span {\n            pointer-events: none;\n        }\n\n        div {\n            pointer-events: none;           \n        }\n    }\n\n    .uploader-nodisplay {\n        display: none;\n    }\n}\n\n\n.filterstate-popover {\n    color: white;\n    background-color: #12234f;\n    border-radius: 3px;\n    box-shadow: 0px 0px 5px #12234f;\n    padding: 5px;\n    width: fit-content;\n    max-width: 500px;\n    font-size: 1.3rem;\n    border: 1px solid #257ee0;\n    cursor: pointer;\n\n    .popover-header {\n        color: white;\n        background-color: #12234f;\n        font-size: 1.5rem;\n        border-bottom: 1px solid rgba(255, 255, 255, .2);\n        padding-bottom: 14px;\n    }\n\n    .popover-body {\n        color: white;\n        background-color: #12234f;\n    }\n}\n\n#filterstate-filter-popover-upload {\n    max-width: 400px\n}\n\n.form-floating {\n    .form-select {\n        color: white;     \n    }\n}\n\n.filter-dropdown-group {\n    height: 58px;\n    width: 100%;\n\n      .filter-dropdown-toggle {\n        height: 58px;\n        width: 100%;     \n        background-color: #051D3E; \n\n        span {\n            width: 90%;\n            display: inline-flex;\n            vertical-align: sub;\n            opacity: .7;\n        }\n      }\n\n      .filter-dropdown-floating {\n        label {\n            font-size: .8em;\n            color: #ffffff5c;\n            transform: translateY(-17px);\n        }     \n      }\n\n      a, input {\n        background-color: #051D3E;\n        border: none;\n        color: white;    \n      }\n}\n\n.filter-dropdown-menu {\n    overflow-y: auto;\n    max-height: 40vh;\n    background-color: unset !important;\n}\n\n\n.fs-query-input {\n    .wmr-dq-button-cont {\n        display: flex;\n        flex-direction: row;\n        padding: 5px;\n    }\n\n    .wmr-dq-button-label {\n        width: 120px; \n        min-width: 120px;\n        margin-left: 10px;\n        vertical-align: sub;\n    }\n\n    .wmr-dq-button-form-label {\n        width: 120px;\n        min-width: 120px;\n        margin-left: 10px;\n    }\n\n    .wmr-dq-button {\n        padding: 0px;\n    }\n\n    .wmr-dq-submit {\n        margin-top: 10px;\n        position: absolute;\n        bottom: 8px;\n        margin-left: 37%;\n\n        .spinners-grow {\n            width: 1.3em;\n            height: 1.3em;\n        }\n    }\n\n    .wmr-dq-submit-status {\n     \n        position: absolute;\n        bottom: 55px;\n        width: 640px;\n        text-align: center;\n\n\n        .alert {\n             height: 30px;\n             padding: 0px;\n             margin-top: 20px;\n        }\n    }\n\n    .fs-column-wqp {\n        display: flex;\n        flex-direction: column;\n        padding: 5px;\n        margin-left: 10px;\n        margin-top: 30px;\n        width: 38%;\n        min-width: 190px;\n        font-size: 1em;\n        max-width: 300px;\n\n        .fs-col-results {\n            display: flex;\n            flex-direction: column;\n            padding: 5px;\n            margin-top: 0px;\n        }\n    }\n\n    .fs-column {\n        padding: 5px;\n\n        form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {\n              color: white;   \n              opacity: 0.65;\n              transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n        }\n\n        .form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after {\n            background-color: unset; \n        }\n\n        .fs-column-floating {\n            label {\n                text-align: center;\n                width: 100%;\n            }\n        }\n\n        .fs-column-button {\n           transform: scale(.8);\n        }\n\n        select, textarea {\n            background-color: #051D3E;\n            border: none;\n            color: #ffffff5c;\n        }\n\n        color:white !important;\n\n        .wmr-dq-dp {\n            width: 100px;\n        }\n\n        .react-datepicker-wrapper {\n            width: 120px !important;\n        }\n\n        form input[type=\"text\"] {\n            background-color: #021d3e;\n            border: none;\n            color: #fff !important;\n        }\n\n        .form-floating {\n            label {\n                white-space:pre-line;\n            }\n        }\n\n        .form-floating input[type=\"text\"] {\n            background-color: #021d3e;\n            border: none;\n            color: #fff !important;\n        }\n    }\n}\n\n\n.filterstate-popover-query {\n   min-width: 690px;\n   height: calc(100vh - 130px);\n   max-height: 720px;\n  .popover-body {\n    padding-top: 5px;\n    padding-left: 10px;\n    padding-bottom: 5px;\n    height: calc(100% - 90px);\n    .fs-query-input {\n        \n        .table-container {\n            max-height: 50vh;\n            overflow: auto;\n\n        }\n    }      \n   }\n}\n\n\n.FilterState {\n    display: inline-flex;\n    align-self: center;\n    margin-right: 12px;\n\n\n    .fs-container {\n        min-width: 143px;\n        color: white;\n        background-color: $darkAndLightModeBackgroundColor; //12234f\n        border-radius: 5px;\n        height: 35px;\n        display: flex;\n        align-items: center;\n        padding-right: 4px;\n\n    }\n\n    .fs-container-wide {\n        min-width: 170px;\n        color: white;\n        background-color: $darkAndLightModeBackgroundColor; //12234f\n        border-radius: 5px;\n        height: 35px;\n        display: flex;\n        align-items: center;\n        padding-left: 4px;\n        padding-right: 1px;\n    }\n\n    .fs-container-date {\n        white-space: nowrap;\n    }\n\n    .fs-calendar-icon {\n        margin-left: 8px;\n        margin-right: 4px;\n    }\n\n    .fs-span {\n        margin-left: 5px;\n        opacity: .8;\n    }\n\n    .fa-filter {\n        margin-left: 10px;\n    }\n\n    .fs-span-app {\n        margin-left: 9px;\n        opacity: .8;\n        pointer-events: none;\n\n        max-width: 13vw;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        padding-right: 4px;\n        overflow: hidden;\n    }\n\n    .fs-span-wide {\n        margin-left: 9px;\n        opacity: .8;\n        pointer-events: none;\n\n        max-width: 18vw;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        padding-right: 4px;\n        overflow: hidden;\n    \n    }\n\n    .fs-span-end {\n        margin-right: 10px;\n        opacity: .8;\n    }   \n\n    #filterstate-filter-div {\n        cursor: pointer;\n    }\n\n    #filterstate-fs-container:hover {\n        background-color: #257ee0;\n        cursor: pointer;\n    }\n\n    #filterstate-filter-div:hover {\n        background-color: #257ee0;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
